export default function getCustomStylesForDatePicker() {
  return {
    sx: {
      "& .MuiInputBase-input": {
        boxShadow: "none",
        fontFamily: "satoshi",
        color: "white",
        fontWeight: "500",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderRadius: "10px",
        borderColor: "#22222255",
        borderWidth: "1px",
      },
      "& .MuiInput-underline:after": {
        borderBottomColor: "white",
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "white",
          textColor: "white",
        },
        "&:hover fieldset": {
          borderColor: "white",
          textColor: "white",
        },
        "&.Mui-focused fieldset": {
          borderColor: "white",
          textColor: "white",
        },
      },
    },
  };
}
